import { Injectable, WritableSignal, signal } from '@angular/core';

export interface TJHighLighted {
  highlight: boolean;
  id: string;
}
@Injectable({
  providedIn: 'root'
})
export class HighlightService {
  private readonly highlightMapSignal: WritableSignal<TJHighLighted> = signal(null);
  public highlightedItem = this.highlightMapSignal.asReadonly();

  public highlightTJ(id: string) {
    this.highlightMapSignal.set({ id, highlight: true });
  }

  public cleanHighlightTJ() {
    this.highlightMapSignal.set(null);
  }
}
